/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewstudenthint3Inputs */

const en_ticketpreviewstudenthint3 = /** @type {(inputs: Ticketpreviewstudenthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show your student ID`)
};

const de_ticketpreviewstudenthint3 = /** @type {(inputs: Ticketpreviewstudenthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studierendenausweis zeigen`)
};

/**
* | output |
* | --- |
* | "Show your student ID" |
*
* @param {Ticketpreviewstudenthint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewstudenthint3 = /** @type {((inputs?: Ticketpreviewstudenthint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewstudenthint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewstudenthint3(inputs)
	return de_ticketpreviewstudenthint3(inputs)
});
export { ticketpreviewstudenthint3 as "ticketPreviewStudentHint" }